/* eslint-disable @typescript-eslint/no-invalid-void-type */
import type { BankingProductPage } from '@models/banking-product-page/banking-product-page';
import type { BankingProduct, BankingProductRequest } from '@models/loyalty-libs';
import type { Observable } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { NotificationsService, NotifStatus } from '@wizbii-components/bo-angular-ui';
import { catchError, of } from 'rxjs';

export type CreateOrUpdateBankingProduct = Omit<BankingProductRequest, 'id'>;

@Injectable({ providedIn: 'root' })
export class BankingProductsWebservice {
  readonly #http = inject(HttpClient);
  readonly #notificationsService = inject(NotificationsService);

  readonly getAll = (partnerId: string): Observable<BankingProduct[]> =>
    this.#http.get<BankingProduct[]>(`${environment.api.obendy}/v4/partner/${partnerId}/banking-products`).pipe(
      catchError(() => {
        this.#notificationsService.createToast(
          'Erreur lors de la récupération des produits financiers',
          NotifStatus.Failed,
          5000
        );
        return of([]);
      })
    );

  readonly put = (
    bankingProductId: string,
    bankingProduct: CreateOrUpdateBankingProduct
  ): Observable<BankingProduct> => {
    return this.#http.put<BankingProduct>(
      `${environment.api.obendy}/v4/banking-products/${bankingProductId}`,
      bankingProduct
    );
  };

  readonly post = (bankingProduct: CreateOrUpdateBankingProduct): Observable<BankingProduct> =>
    this.#http.post<BankingProduct>(`${environment.api.obendy}/v4/banking-products`, bankingProduct);

  readonly delete = (bankingProductId: string): Observable<void> =>
    this.#http.delete<undefined>(`${environment.api.obendy}/v4/banking-products/${bankingProductId}`);

  readonly get = (bankingProductId: string): Observable<BankingProduct> =>
    this.#http.get<BankingProduct>(`${environment.api.obendy}/v4/banking-products/${bankingProductId}`);

  readonly getPage = (partnerId: string): Observable<BankingProductPage> =>
    this.#http.get<BankingProductPage>(
      `${environment.api.obendy}/v1/partner-revision/${partnerId}/pages/banking-product`
    );

  readonly savePage = (partnerId: string, page: BankingProductPage): Observable<BankingProductPage> =>
    this.#http.put<BankingProductPage>(
      `${environment.api.obendy}/v1/partner-revision/${partnerId}/pages/banking-product`,
      page
    );
}
